// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qmI-","title":"Header_title__dnl-J","left":"Header_left__28bSR","clinicName":"Header_clinicName__3Aprz"};